export const AUTH_CONFIG = {
  requests: {
    login: {
      url: `auth/login`,
    },
    profile: {
      url: `auth/me`,
    },
    refreshToken: {
      url: `auth/refresh`, 
    },
    logout: {
      url: `auth/logout`
    }
  }
};
  